<template>
  <div id="fileList">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
              v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
              v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
              @click="$router.push('/administrator/config-sync-htttn-add.html')">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>

          <template #certificate="{ item }">
            <td @click="setupGetCertificate(item)">
              <span v-if="item.certificate != null && item.certificate != ''">
                {{ item.certificate }}
              </span>
              <span v-else>
                ********
              </span>
            </td>
          </template>

          <template #isSync="{ item }">
            <td v-if="item.isSync == true">
              <span class="dot-custom dot-success">
                Đồng bộ
                <BaseSwitch class="mx-1" color="success" checked variant="3d" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_isSync', item.id, item.name, item.isSync)" />
              </span>
            </td>

            <td v-else>
              <span class="dot-custom dot-danger">
                Không đồng bộ
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_isSync', item.id, item.name, item.isSync)" />
              </span>
            </td>
          </template>

          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline"
                  v-c-tooltip.hover="'Cập nhật thông tin xác thực'" square size="sm" @click="openPopupUpdateCertificate(item)">
                  <i class="fa fa-lock" />
                </CButton>
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'"
                  square size="sm" @click="$router.push(`/administrator/${item.id}/config-sync-htttn-update.html`)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="danger" variant="outline" square size="sm"
                  v-c-tooltip.hover="'Xóa'" @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal :title="'Cập nhật thông tin xác thực'" :show.sync="isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataSave.userNameInput.options" :data="dataSave.userNameInput.data"
            :listener="dataSave.userNameInput.listener" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataSave.passwordInput.options" :data="dataSave.passwordInput.data"
            :listener="dataSave.passwordInput.listener" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa fa-save"></i>
          Lưu lại
        </button>
      </template>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>


  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import BaseSwitch from "@/views/base/BaseSwitch";

export default {
  name: "ConfigSyncHtttnList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseModal,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/config-sync-htttn/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "cấu hình",
          that.actionData.model.configName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.configId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: "Xóa cấu hình " + that.actionData.model.configName + " thành công" });
        that.loadDataMainTable();
      }
    });
    actionTypeMapping.set("update_isSync", {
      url: "/config-sync-htttn/updateIsSync",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.isSync == true ? "tắt đồng bộ" : "mở đồng bộ", "cấu hình", that.actionData.model.configName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.configId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: that.actionData.model.userIsEnable == true ? "Tắt đồng bộ thành công" : "Mở đồng bộ thành công" });
        that.loadDataMainTable();
      },
    });
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      isShowModal: false,
      isSelectedAllDevices: false,
      loading: {
        value: false,
      },
      dataSave: {
        idField: {
          data: {
            name: "id",
            model: ""
          }
        },
        userNameInput: {
          options: {
            label: "Tài khoản <span class='required'>*</span>",
            placeholder: "Tài khoản",
          },
          data: {
            name: "userName",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.userNameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tài khoản không được để trống";
                } else if (value.length > 256) {
                  this.isValid = false;
                  this.errorMessage = "Tài khoản được quá 256 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        passwordInput: {
          options: {
            label: "Mật khẩu <span class='required'>*</span>",
            placeholder: "Mật khẩu",
            type: "password"
          },
          data: {
            name: "password",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.passwordInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Mật khẩu không được để trống";
                } else if (value.length > 256) {
                  this.isValid = false;
                  this.errorMessage = "Mật khẩu được quá 256 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        }
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          configId: null,
          configName: null
        }
      },
      titleInput: {
        options: {
          placeholder: "Tên cấu hình",
          label: "Tên cấu hình",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
            { key: "name", label: "Tên" },
            { key: "location", label: "Địa bàn" },
            { key: "isSync", label: "Trạng thái" },
            { key: "certificate", label: "Xác thực" },
            { key: "urlToken", label: "Url Token" },
            { key: "urlSyncDevice", label: "Url Sync Device" },
            { key: "urlSyncSchedule", label: "Url Sync Schedule" },
            { key: "urlSyncCancelSchedule", label: "Url Sync Cancel Schedule" },
            { key: "urlSyncHistory", label: "Url Sync History" },
            { key: "version", label: "Version" },
            { key: "action", label: "Thao tác", _classes: "action-sticky-group", _style: "", sorter: false, filter: false },
          ],
          slots: [
            "index", "createDate", "isSync", "certificate", "action"
          ],
          pageSize: 20,
          sorter: true,
          columnFilter: false,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/config-sync-htttn/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, configId, configName, isSync) {
      let actionData = this.actionData.model;
      actionData.configId = configId || null;
      actionData.configName = configName || null;
      actionData.isSync = isSync
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },

    setupGetCertificate: function (item) {
      let that = this;

      if (item.certificate == null || item.certificate == '') {
        this.$helper.loadDataSource({
          url: "/config-sync-htttn/get-certificate",
          isJsonContentType: false,
          dataSubmit: function () {
            return { id: item.id }
          },
          successCallback: function (response) {
            item.certificate = response.data.data;
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      } else {
        item.certificate = ''
      }
    },

    openPopupUpdateCertificate: function (item) {
      this.dataSave.idField.data.model = item.id;
      this.isShowModal = true;
    },

    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.dataSave.userNameInput.data.validator.valid();
      isValid &= this.dataSave.passwordInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      let dataRequest = {
        id: this.dataSave.idField.data.model,
        userName: this.dataSave.userNameInput.data.model,
        password: this.dataSave.passwordInput.data.model,
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/config-sync-htttn/update-certificate",
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật cấu hình thành công"
            });
            that.isShowModal = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>